import React from 'react';
import styles from './styles.module.scss';
import moment from 'moment-timezone';
import i18n from '../../../i18n';
import LimitedLinesTextBlock from '../../Common/LimitedLinesTextBlock';
import ctx from 'classnames';
import { StarRating } from '../../StarRating';

interface ComponentProps {
  author: string;
  modifiedTime: number;
  body: string;
  isSelf?: boolean;
  id: string;
  isResponse?: boolean;
  rating?: number;
}

const getAuthorName = (author: string, isSelf: Maybe<boolean>): string => {
  return author + (!!isSelf ? '(You)' : '');
}

export const CommentBody: React.FC<ComponentProps> = ({author, modifiedTime, body, isSelf, id , isResponse, rating}): Nullable<JSX.Element> => {
  if (!author) return null;
  return (
    <div className={ctx({[styles.developerResponse]: isResponse})} data-testid='commentBody'>
      <div className={styles.author}>
        <p>
        {getAuthorName(author, isSelf)}
        </p>
      </div>
      <div className={styles.date}>
        <p>{moment(modifiedTime).locale(i18n.language).format('LL')}</p>
      </div>
      {rating && <StarRating rating={rating} size={'small'} />}
      <div className={styles.body}>
        <LimitedLinesTextBlock numberOfLines={4} body={body} marginBottom={1.5}/>
      </div>
    </div>
  )

}
